/**
 * Updated by Thomas Junghans 19.8.2013. Added text container span.txtValue
 * Updated by Cesar Keller 16.12.2014. Added support for disabled="disabled"
 * 		Usage: $('select').prop('disabled', true).closest('.field').addClass('disabled')
 */
(function($){
	/* jshint quotmark: false */
	/* jslint plusplus: true */
	/* jslint eqeq: true */
	/* jshint indent: false */
	/* jshint curly: false */
	/* jshint latedef: false */
	/* jshint maxstatements: false */

	"use strict";

	//add class to html tag
	$('html').addClass('stylish-select');
	//create cross-browser indexOf
	$('.field').on('load', function(){
		if (!Array.prototype.indexOf) {
			Array.prototype.indexOf = function (obj, start) {
				for (var i = (start || 0); i < this.length; i++) {
					if (this[i] === obj) {
						return i;
					}
				}
			};
		}
	});

	//utility methods
	$.fn.extend({
		getSetSSValue: function(value){
			if (value){
				//set value and trigger change event
				$(this).val(value).change();
				return this;
			} else {
				return $(this).find(':selected').val();
			}
		},
		/**
		 * Usage: $('select').resetSS() after the select has been updated. Resets and ReInitialises.
		 *
		 * @author Justin Beasley, updated by Thomas Junghans 19.8.2013
		 */

		resetSS: function(){

			return this.each(function(){

				var $this = $(this),
					oldOpts = $this.data('ssOpts');

				$this
					.next()
					.remove();

				$this
					.addClass('customDropDown')
					.css({
						'position' : null,
						'left': ''
					})

					//unbind all events and redraw
					.off('.sSelect').sSelect(oldOpts);
			});
		}
	});

	$.fn.sSelect = function(options) {

		return this.each(function(){

			var $input = $(this);

					$input.trigger('beforeInit.sSelect'); // added by David Talamona

			if (!$input.is('.customDropDown')) {
				return;
			}

			$input.removeClass('customDropDown');

			var defaults = {
				defaultText: 'Please select',
				animationSpeed: 0, //set speed of dropdown
				ddMaxHeight: '', //set css max-height value of dropdown
				containerClass: '' //additional classes for container div
			};

			//initial variables
			var opts = $.extend(defaults, options),
				$containerDivArrow = $('<div class="arrow"></div>'),
				$containerDivText = $('<div class="selectedTxt"><span class="txtValue"></span></div>'),
				$containerDiv = $('<div class="newListSelected ' + opts.containerClass + '"></div>'),
				$newUl = $('<ul class="newList" style="visibility:hidden;"></ul>'),
				itemIndex = -1,
				currentIndex = -1,
				keys = [],
				seekTerm = "",
				seekTimeout = false,
				prevKey = false,
				prevented = false,
				$newLi;


			//added by Justin Beasley
			$input.data('ssOpts',options);

			//build new list
			$containerDiv.insertAfter($input);

			if($input.attr('disabled')){
				$containerDiv.addClass("disabled");
			}

			var tabIndex = $input.attr("tabindex");
			if (tabIndex == -1) {
				$containerDiv.attr("tabindex", "0");
			} else {
				$containerDiv.attr("tabindex", tabIndex || "0");
			}
			$containerDivText.prependTo($containerDivArrow);
			$containerDivArrow.prependTo($containerDiv);
			$newUl.appendTo($containerDiv);

			$input.css({"position" : "absolute", "left" : "-99999px"});

			//added by Justin Beasley (used for lists initialized while hidden)
			$containerDivText.data('ssReRender',!$containerDivText.is(':visible'));

			//test for optgroup
			if ($input.children('optgroup').length === 0){
				$input.children().each(function(i){
					var option = $(this).html();
					var key = $(this).val();

					//add first letter of each word to array
					keys.push(option.charAt(0).toLowerCase());
					if ($(this).attr('selected') || this.selected){ // added " || this.selected" by Thomas Amsler
						opts.defaultText = option;
						currentIndex = i;
					}
					$newUl.append($('<li><a href="javascript:void(0);">'+option+'</a></li>').data('key', key));

				});
				//cache list items object
				$newLi = $newUl.children().children();

			} else { //optgroup
				$input.children('optgroup').each(function(){

					var optionTitle = $(this).attr('label'),
					$optGroup = $('<li class="newListOptionTitle">'+optionTitle+'</li>');

					$optGroup.appendTo($newUl);

					var $optGroupList = $('<ul></ul>');

					$optGroupList.appendTo($optGroup);

					$(this).children().each(function(){
						++itemIndex;
						var option = $(this).html();
						var key = $(this).val();
						//add first letter of each word to array
						keys.push(option.charAt(0).toLowerCase());
						if ($(this).attr('selected') || this.selected) { // added " || this.selected" by Thomas Amsler
							opts.defaultText = option;
							currentIndex = itemIndex;

						}
						$optGroupList.append($('<li><a href="javascript:void(0);">'+option+'</a></li>').data('key',key));
					});
				});
				//cache list items object
				$newLi = $newUl.find('ul li a');
			}

			//get heights of new elements for use later
			var newUlHeight = $newUl.height(),
			containerHeight = $containerDiv.height(),
			newLiLength = $newLi.length;

			//check if a value is selected
			if (currentIndex != -1){
				navigateList(currentIndex, true);

			} else {
				//set placeholder text
				$containerDivText.find('.txtValue').html(opts.defaultText);

			}

			//decide if to place the new list above or below the drop-down
			function newUlPos(){
								if ($input.data('autoPosition') === false) return; // added by David Talamona
				var containerPosY = $containerDiv.offset().top,
				docHeight = window.jQuery(window).height(),
				scrollTop = window.jQuery(window).scrollTop();

				//if height of list is greater then max height, set list height to max height value
				if (newUlHeight > parseInt(opts.ddMaxHeight, 10)) {
					newUlHeight = parseInt(opts.ddMaxHeight, 10);
				}

				containerPosY = containerPosY-scrollTop;
				if (containerPosY+newUlHeight >= docHeight){
					$newUl.css({
						top: '18px',
						height: newUlHeight
					});
					$input.onTop = true;
				} else {
					$newUl.css({
						top: '18px',
						height: newUlHeight
					});
					$input.onTop = false;
				}
			}

			//run function on page load
			newUlPos();

			//run function on browser window resize
			$(window).on('resize.sSelect scroll.sSelect', newUlPos);

			//positioning
			function positionFix(){
				$containerDiv.css('position','relative');
			}

			function positionHideFix(){
				$containerDiv.css('position','static');
			}

			$containerDivArrow.on('click.sSelect',function(event){
				event.stopPropagation();

				// added by Cesar Keller
				if ($input.is(':disabled')) {
					return;
				}

				//added by Justin Beasley
				if($(this).data('ssReRender')) {
					newUlHeight = $newUl.height('').height();
					containerHeight = $containerDiv.height();
					$(this).data('ssReRender',false);
					newUlPos();
				}

				//hide all menus apart from this one
				$('.newList').not($newUl).hide() // changed by Raphael Schweikert
					.parent()
						.css('position', 'static')
						.removeClass('newListSelFocus');

				//show/hide this menu
				$newUl.toggle();
								$containerDiv[($newUl.is(':visible')?'add':'remove') + 'Class']('newListSelOpen'); // added by David Talamona
				positionFix();
				//scroll list to selected item
				$newLi.eq(currentIndex).focus();

								$input.trigger('list' + ($newUl.is(':visible')?'Open':'Close') + '.sSelect'); // added by David Talamona

			});

			// select item
			$newLi.on('click.sSelect',function(e){
				var $clickedLi = $(e.target);

				//update counter
				currentIndex = $newLi.index($clickedLi);
				// Made Selecte box selected
				$(this).parent().parent().parent().prev().children().attr('selected', false);
				$(this).parent().parent().parent().prev().children().eq(currentIndex).attr('selected', true);

				//remove all hilites, then add hilite to selected item
				prevented = true;
				navigateList(currentIndex);
				$containerDiv.removeClass('newListSelOpen'); // added by David Talamona
				$newUl.hide();
				positionHideFix();//ie // modified by David Talamona
								$input.trigger('listClose.sSelect'); // added by David Talamona
			});

			$newLi.on('mouseenter.sSelect',
				function(e) {
					var $hoveredLi = $(e.target);
					$hoveredLi.addClass('newListHover');
				}
			).on('mouseleave.sSelect',
				function(e) {
					var $hoveredLi = $(e.target);
					$hoveredLi.removeClass('newListHover');
				}
			);

			function navigateList(currentIndex, init){
				$newLi.removeClass('hiLite')
				.eq(currentIndex)
				.addClass('hiLite');

				$newLi.parent().removeClass('hiLite').end().eq(currentIndex).parent().addClass('hiLite'); // added by David Talamona

				if ($newUl.find('li').eq(currentIndex+1).length){
					$newUl.scrollTop($newUl.scrollTop() + $newUl.find('li').eq(currentIndex+1).position().top);
				}

				if ($newUl.is(':visible')){
					$newLi.eq(currentIndex).focus();
				}

				var text = $newLi.eq(currentIndex).html();
				var val = $newLi.eq(currentIndex).parent().data('key');

				//page load
				if (init){
					$input.val(val);
					$containerDivText.find('.txtValue').html(text);
					return false;
				}

				try {
					$input.val(val);
				} catch(ex) {
					// handle ie6 exception
					$input[0].selectedIndex = currentIndex;
				}

				$input.change();
				$input.trigger('change');
				$containerDivText.find('.txtValue').html(text);
			}

			$input.on('change.sSelect',function(event){
				var $targetInput = $(event.target);
				//stop change function from firing
				if (prevented){
					prevented = false;
					return false;
				}
				var $currentOpt = $targetInput.find(':selected');

				//currentIndex = $targetInput.find('option').index($currentOpt);
				currentIndex = $targetInput.find('option').index($currentOpt);

				navigateList(currentIndex, true);
			});

			//handle up and down keys
			function keyPress(element) {
				//when keys are pressed
				$(element).off('keydown.sSelect').on('keydown.sSelect',function(e){
					var keycode = e.which;

					// added by Cesar Keller
					if ($input.is(':disabled')) {
						return;
					}

					//prevent change function from firing
					prevented = true;

					switch(keycode) {
						case 40: //down
						case 39: //right
							incrementList();
							return false;
						case 38: //up
						case 37: //left
							decrementList();
							return false;
						case 33: //page up
						case 36: //home
							gotoFirst();
							return false;
						case 34: //page down
						case 35: //end
							gotoLast();
							return false;
						case 13:
						case 27:
							$containerDiv.removeClass('newListSelOpen'); // added by David Talamona
							$newUl.hide();
							positionHideFix();
							$input.trigger('listClose.sSelect'); // added by David Talamona
							return false;
						case 9: // tab -> leafe field // added by David Talamona
							return true;
						case 16: // Ignore 'SHIFT'// added by Nikola Tica
							return true;
					}

					//check for keyboard shortcuts
					var keyPressed = String.fromCharCode(keycode).toLowerCase();

					seekTerm+=keyPressed;

					if (seekTimeout && typeof seekTimeout.clearTimeout === 'function') seekTimeout.clearTimeout();

					if(findDropdownItem(seekTerm) >= 0){
						currentIndex = findDropdownItem(seekTerm);
					} else if(findDropdownItem(keyPressed) >= 0){
						seekTerm = keyPressed;
						currentIndex = findDropdownItem(seekTerm);
					} else {
						seekTerm = "";
						currentIndex = 0;
					}

					if (seekTerm){
						seekTimeout = setTimeout(function(){
							seekTerm = "";
						}, 1000);
					}
					navigateList(currentIndex);
					//store last key pressed
					prevKey = keyPressed;
					return false;
				});
			}

			function findDropdownItem(term){
				var $options = $input.find('option[value!=""]');
				for(var i=0,ii=$options.length; i < ii; i++){
					var option = $options.eq(i).html();
					if (option.substr(0, term.length).toLowerCase() === term.toLowerCase()){
						return $options.eq(i).index();
					}
				}
				return false;
			}

			function incrementList(){
				if (currentIndex < (newLiLength-1)) {
					++currentIndex;
					navigateList(currentIndex);
				}
			}

			function decrementList(){
				if (currentIndex > 0) {
					--currentIndex;
					navigateList(currentIndex);
				}
			}

			function gotoFirst(){
				currentIndex = 0;
				navigateList(currentIndex);

			}

			function gotoLast(){
				currentIndex = newLiLength-1;
				navigateList(currentIndex);
			}

			$containerDiv.on('click.sSelect',function(e){
				e.stopPropagation();
				keyPress(this);
			});

			$containerDiv.on('focus.sSelect',function(){
				// added by Cesar Keller
				if ($input.is(':disabled')) {
					$(this).removeClass('newListSelFocus');
					return;
				}

				$(this).addClass('newListSelFocus');
				keyPress(this);
			});

			$containerDiv.on('blur.sSelect',function(){
				$(this).removeClass('newListSelFocus');
				// added by Matthias Inauen -> so the select menu closes properly if the user clicks on another select menu
				if(!$containerDiv.is('.newListSelHover') && $containerDiv.is('.newListSelOpen')) {
					$(document).trigger('click.sSelect');
				}
			});

			//hide list on blur
			$(document).on('click.sSelect',function(){
				$containerDiv.removeClass('newListSelFocus');
				if (!$containerDiv.is('.newListSelOpen')) return; // added by David Talamona -> do not close the dopdown every time the page is clicked ANYWHERE
				$containerDiv.removeClass('newListSelOpen'); // added by David Talamona
				$newUl.hide();
				positionHideFix();
				$input.trigger('listClose.sSelect'); // added by David Talamona
			});

			//add classes on hover
			$containerDivText.on('mouseenter.sSelect',
				function(e) {
					var $hoveredTxt = $(e.target);
					$hoveredTxt.parent().addClass('newListSelHover');
				}
			).on('mouseleave.sSelect',
				function(e) {
					var $hoveredTxt = $(e.target);
					$hoveredTxt.parent().removeClass('newListSelHover');
				}
			);

			// added by David Talamona (following listener-block)
			$containerDiv.on('mouseenter.sSelect',
				function() {
					$(this).addClass('newListSelHover');
				}
			).on('mouseleave.sSelect',
				function() {
					$(this).removeClass('newListSelHover');
				}
			);

			//reset left property and hide
			$newUl.css({
				left: '8px',
				display: 'none',
				visibility: 'visible',
				position: 'absolute'
			});

			$input.trigger('afterInit.sSelect'); // added by David Talamona

			if (!!navigator.userAgent.match(/Trident.*rv\:11\./) && currentIndex >= 0) { // added by Nikola Tica
				$containerDiv.find('ul > li').eq(currentIndex).trigger('click');
			}
		});

	};

})(window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/vendor/jquery.stylish-select.js
// module id = 261
// module chunks = 0